import React from "react"

import { Icon, InfoFilled } from "@cgtrader/triangle-ui/dist/src/ssr-index"
import { bool } from "prop-types"

import { useIs3dPrintModel } from 'Pods/ItemPage/TopSection/hooks/useTopSectionProps'

function UseCasePermissionMessage({ isBuyerWithAnUseCase, isFreeModel, isDownloaded = false }) {
  const is3dPrintModel = useIs3dPrintModel()
  let message

  if (isBuyerWithAnUseCase) {
    message = is3dPrintModel
      ? 'You already posted a 3D Make for this model.'
      : 'You already posted an Use Case for this model.'
  } else if (isFreeModel && !isDownloaded) {
    message = 'You need to download this model to add 3D Makes'
  } else {
    message = 'Purchase this model to share your 3D Make and inspire others.'
  }

  return (
    <div className="use-cases-area__needs-permission-container">
      <Icon svgComponent={InfoFilled} color="info" />
      <span>{message}</span>
    </div>
  )
}

UseCasePermissionMessage.propTypes = {
  isBuyerWithAnUseCase: bool.isRequired,
  isFreeModel: bool.isRequired,
  isDownloaded: bool,
}

export default UseCasePermissionMessage
